export function mergeMaps<K, V>(map1: Map<K, V>, map2?: Map<K, V>): Map<K, V> {
    if (!map2) return map1;
    const mergedMap = new Map(map1);
    map2.forEach((value, key) => {
        mergedMap.set(key, { ...map1.get(key), ...value } as V);
    });
    return mergedMap;
}

export function getInitialActiveFiltersFromSearchParams(
    searchParams: URLSearchParams,
    searchKeys?: string[],
    filterKeys?: string[],
    queryKeyMap?: Map<string, string>
): Record<string, string[]> | undefined {
    const filterQueryKeys = filterKeys?.map((key) => queryKeyMap?.get(key) || key) ?? [];
    const keys = filterKeys?.includes('waiting') ? ['before', 'after', ...(searchKeys ?? []), ...filterQueryKeys] : [...(searchKeys ?? []), ...filterQueryKeys];
    const activeFilters = keys.reduce<Record<string, string[]>>((filters, key) => {
        const values = searchParams.getAll(key);
        if (values.length > 0) {
            filters[key] = values;
        }
        return filters;
    }, {});

    return Object.keys(activeFilters).length > 0 ? activeFilters : undefined;
}
